import { filterListToOptionsGroups, filterListToOptionsUsers } from '@/ui/helpers';
import { useTask } from '@/ui/concerns/index';
import { filter as getAllUsers } from '@/services/api/resources/user';
import { ref } from 'vue';
import { FilterList } from '@/entities/filter/model';
import { SelectOptions } from '@/ui/types';

export function useAssignees() {
  const assigneeOptions = ref<SelectOptions<string>>([]);
  const groupsOptions = ref<FilterList>({ data: [] });

  const fillGroupsOptions = (groups: { data: BaseFilterEntity[] }) => {
    groupsOptions.value = groups;
  };

  const fillAssigneeOptions = (users: { data: BaseFilterEntity[] }) => {
    assigneeOptions.value = [
      ...filterListToOptionsUsers(users.data),
      ...filterListToOptionsGroups(groupsOptions.value.data),
    ];

    return assigneeOptions.value;
  };

  const getUsers = useTask(() => getAllUsers(), (users: { data: BaseFilterEntity[] }) => {
    fillAssigneeOptions(users);
  });

  return {
    assigneeOptions,
    groupsOptions,
    fillAssigneeOptions,
    fillGroupsOptions,
    getUsers,
  };
}
